import { useEffect, useRef, useState } from "react"
import { getObject } from "../services/algolia";
import { AlgoliaFinishHit, AlgoliaPaletteHit, RawFinishData } from "../types/AlgoliaTypes";
import { FinishCard } from "../components/FinishCard/FinishCard";
import { useNavigate, useParams } from "react-router-dom";
import { getPaletteByRouterValue, getPaletteObject } from "../services/algoliaPaletteService";
import { PLACEHOLDER_IMAGE } from "../data/constants";
import SteelcaseImage from "../components/layout/SteelcaseImage/SteelcaseImage";

export default function PaletteDetailsPage() {
    let { palette_id } = useParams();
    const navigate = useNavigate();
    const [paletteData, setPaletteData] = useState<AlgoliaPaletteHit>();
    const [featuredMaterials, setFeaturedMaterials] = useState<AlgoliaFinishHit[]>();
    const rightColRef = useRef<HTMLDivElement>(null);


    const retrievePalette = async () => {
        if(palette_id) {
            const paletteObj = await getPaletteByRouterValue(palette_id)
            setPaletteData(paletteObj);
            if(paletteObj.assetRelationships){
                await getMaterials(paletteObj.paletteRelationships);
            }
        }
    }

    const getMaterials = async (materialIds: string[]) => {
        try {
            const isFulfilled = <T,>(p:PromiseSettledResult<T>): p is PromiseFulfilledResult<T> => p.status === 'fulfilled';


            const materialArr = await Promise.allSettled(materialIds.map((id) => {
                const obj = getObject(id)
                if(obj !== null || obj !== undefined){
                    return obj;
                }
              }))
            const response = materialArr.find(isFulfilled)!.value
            const fulfilledValues = materialArr && materialArr.filter(isFulfilled).map(p => p.value);
            const filteredFulfilledValues = fulfilledValues.filter(p => p !== undefined)
            setFeaturedMaterials(filteredFulfilledValues as AlgoliaFinishHit[]);
        } catch {
             
        }
    }

    useEffect(() => {
        retrievePalette();
    }, [])

    useEffect(() => {
        const handleScroll = () => {
          const rightCol = rightColRef.current;
          if (!rightCol) return; 
    
          const rect = rightCol.getBoundingClientRect();
          const isAtBottom = rect.bottom <= window.innerHeight;
    
          // If the bottom of the right column is at or below the viewport bottom,
          // enable scrolling in the right column only
          rightCol.style.overflowY = isAtBottom ? "auto" : "hidden";
        };
    
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
      }, []); 

    return (
        <div className="palette-details__wrapper fl-container__flex fl-container__flex--gap fl-container__content">
            <div className="palette-details__header">
                <h2>
                    {paletteData?.name}
                </h2>
                <p>
                    {paletteData?.description}
                </p>
            </div>
            <div className="palette-details__separator"></div>
            <div className="palette-details__main-content">
                <div className="palette-details__left-col">
                    <div className="palette-details__featured">
                        <div className="palette-details__left-col-images">
                            {/* Fetch images and loop here */}
                            {
                                paletteData?.assetRelationships && paletteData?.assetRelationships.map((asset, idx) => {
                                    if(asset === null) {
                                        return;
                                    }
                                    if(idx === 0 || idx === 3 || idx === 6){
                                        return (
                                            <div className="palette-details__left-col-one-col">
                                                <SteelcaseImage src={asset} altText={paletteData.name} loading={"lazy"} />
                                            </div> 
                                        )
                                    } else {
                                        return (
                                            <div className="palette-details__left-col-two-col palette-details__left-col-two-col--image-group">
                                                {paletteData && paletteData.assetRelationships && paletteData.assetRelationships[idx] ? <SteelcaseImage src={paletteData.assetRelationships[idx]} altText={paletteData.name} loading="lazy" /> : null}
                                                {paletteData && paletteData.assetRelationships && paletteData.assetRelationships[idx + 1] ? <SteelcaseImage src={paletteData.assetRelationships[idx+1]} altText={paletteData.name} loading="lazy" /> : null}
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="palette-details__right-col" ref={rightColRef}>
                    {
                        featuredMaterials &&
                            featuredMaterials?.map((material, idx) => {
                                return (
                                    <div key={`${material.objectID}-material-${idx}`}>
                                        <FinishCard finish={material}/>
                                    </div>
                                )
                            })
                    }
                </div>
            </div>
        </div>
    )
}